/**
 * Created by IL on 22.10.2015.
 */

export const name: string = 'resource-manager';
export const moduleName: string = 'pdc-widget-resource-manager';
export const icon: string = 'dashboard';
export const namespace: string = 'business-intelligence';
//export const priority: number = 1;
